declare namespace $ {

	type $shm_hitalama_hovered__hovered_shm_hitalama_map_widget_float_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['head'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__event_shm_hitalama_map_widget_float_4 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float['content_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float['content_pointerdown'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['content_wrapper'] >
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_scroll__style_shm_hitalama_map_widget_float_6 = $mol_type_enforce<
		({ 
			'overflow': ReturnType< $shm_hitalama_map_widget_float['content_scroll_overflow'] >,
			'backgroundColor': ReturnType< $shm_hitalama_map_widget_float['background_style'] >,
			'borderColor': ReturnType< $shm_hitalama_map_widget_float['border_color_style'] >,
			'borderWidth': ReturnType< $shm_hitalama_map_widget_float['border_width_px'] >,
			'borderStyle': ReturnType< $shm_hitalama_map_widget_float['border_style'] >,
		})  & ReturnType< $mol_scroll['style'] >
		,
		ReturnType< $mol_scroll['style'] >
	>
	type $mol_scroll__event_shm_hitalama_map_widget_float_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float['content_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float['content_pointerdown'] >,
		})  & ReturnType< $mol_scroll['event'] >
		,
		ReturnType< $mol_scroll['event'] >
	>
	type $mol_link_iconed__sub_shm_hitalama_map_widget_float_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_link_iconed__uri_shm_hitalama_map_widget_float_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['link_url'] >
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_link_iconed__external_shm_hitalama_map_widget_float_10 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link_iconed['external'] >
	>
	type $mol_link_iconed__style_shm_hitalama_map_widget_float_11 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_widget_float['widget_link_transform'] >,
		}) 
		,
		ReturnType< $mol_link_iconed['style'] >
	>
	type $mol_link_iconed__event_shm_hitalama_map_widget_float_12 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float['widget_link_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float['widget_link_pointerdown'] >,
		})  & ReturnType< $mol_link_iconed['event'] >
		,
		ReturnType< $mol_link_iconed['event'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['link_str'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['toolbar_type'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_16 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_widget_float['toolbar_transform'] >,
			'top': ReturnType< $shm_hitalama_map_widget_float['toolbar_style_top'] >,
			'width': string,
			'maxWidth': ReturnType< $shm_hitalama_map_widget_float['toolbar_tools_max_width'] >,
			'marginLeft': ReturnType< $shm_hitalama_map_widget_float['toolbar_tools_left'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_18 = $mol_type_enforce<
		({ 
			'pointerEvents': ReturnType< $shm_hitalama_map_widget_float['drag_overlap_pointer_events'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_shm_hitalama_map_widget_float_19 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float['content_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float['content_pointerdown'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_link_iconed__sub_shm_hitalama_map_widget_float_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_link_iconed__uri_shm_hitalama_map_widget_float_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['open_in_new_uri'] >
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_link_iconed__external_shm_hitalama_map_widget_float_22 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link_iconed['external'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_23 = $mol_type_enforce<
		({ 
			'height': ReturnType< $shm_hitalama_map_widget_float['fullsize_height'] >,
			'minHeight': ReturnType< $shm_hitalama_map_widget_float['fullsize_min_height'] >,
			'minWidth': string,
			'color': ReturnType< $shm_hitalama_map_widget_float['color'] >,
			'fontSize': ReturnType< $shm_hitalama_map_widget_float['font_size_px'] >,
			'fontFamily': ReturnType< $shm_hitalama_map_widget_float['font_family'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_tools__widget_shm_hitalama_map_widget_float_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['widget'] >
	>
	type $shm_hitalama_map_widget_tools__Map_page_shm_hitalama_map_widget_float_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['Map_page'] >
	>
	type $shm_hitalama_map_widget_tools__tools_custom_shm_hitalama_map_widget_float_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['tools_custom'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['tools_custom'] >
	>
	type $shm_hitalama_map_widget_tools__settings_content_shm_hitalama_map_widget_float_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['settings_content'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['settings_content'] >
	>
	type $shm_hitalama_map_widget_contextmenu__widget_shm_hitalama_map_widget_float_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu['widget'] >
	>
	type $shm_hitalama_map_widget_contextmenu__Map_page_shm_hitalama_map_widget_float_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu['Map_page'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_map_widget_float extends $shm_hitalama_map_float {
		link_str( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float['widget'] >['link_str'] >
		hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		Open_in_new_icon( ): $mol_icon_open_in_new
		open_in_new_uri( ): string
		fullsize_height( ): string
		fullsize_min_height( ): string
		controls( ): readonly(any)[]
		content( ): readonly(any)[]
		title( next?: string ): string
		Widget_title( ): $mol_text
		head( ): readonly(any)[]
		content_pointerdown( next?: any ): any
		Widget_head( ): $mol_view
		content_wrapper( ): readonly(any)[]
		content_scroll_overflow( ): string
		background_style( ): string
		border_color_style( ): string
		border_width_px( ): string
		border_style( ): string
		Content_scroll( ): $mol_scroll
		bind_view( ): any
		editing( ): boolean
		auto_height_fit( ): any
		tools_custom( ): readonly(any)[]
		settings_content( ): readonly(any)[]
		settings_tool_visible( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float['Tools'] >['settings_tool_visible'] >
		settings_bubble_content( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float['Tools'] >['settings_bubble_content'] >
		Widget_link_icon( ): $mol_icon_link_variant
		link_url( ): string
		widget_link_transform( ): string
		widget_link_pointerdown( next?: any ): any
		Widget_link( ): $mol_link_iconed
		Contextmenu_common( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float['Contextmenu'] >['Contextmenu_common'] >
		toolbar_style_top( ): string
		toolbar_tools_max_width( ): string
		toolbar_tools_left( ): string
		Link_str( ): $mol_paragraph
		toolbar_type( ): string
		Toolbar_type( ): $mol_paragraph
		Toolbar_top( ): $mol_view
		Toolbar( ): $mol_view
		drag_overlap_pointer_events( ): string
		Drag_overlap( ): $mol_view
		opacity_str( ): string
		event_contextmenu( next?: any ): any
		pointerdown( next?: any ): any
		contextmenu_body( ): readonly(any)[]
		auto_height( ): boolean
		fullscreen_attr( ): boolean
		selected_attr( ): boolean
		dragged_attr( ): boolean
		locked_selected( ): boolean
		locked_attr( ): boolean
		hover_styled( next?: boolean ): boolean
		is_inner( next?: boolean ): boolean
		control_attr( next?: boolean ): boolean
		widget( ): $shm_hitalama_map_widget
		map( ): $shm_hitalama_map
		scrollable( ): boolean
		plugins( ): readonly(any)[]
		Open_in_new( ): $mol_link_iconed
		head_showed( next?: boolean ): boolean
		Fullsize_wrapper( ): $mol_view
		head_view( ): readonly(any)[]
		sub_common( ): readonly(any)[]
		sub_scrollable( ): readonly(any)[]
		sub( ): readonly(any)[]
		auto( ): readonly(any)[]
		Tools( ): $shm_hitalama_map_widget_tools
		widget_link( ): readonly(any)[]
		Contextmenu( ): $shm_hitalama_map_widget_contextmenu
		toolbar( ): readonly(any)[]
		delete_from_map( ): any
		drag_overlap( ): readonly(any)[]
		opacity( next?: number ): number
		has_scrollbar_x( ): boolean
		has_scrollbar_y( ): boolean
		skip_drag( id: any): boolean
		color( ): string
		style( ): ({ 
			'opacity': ReturnType< $shm_hitalama_map_widget_float['opacity_str'] >,
		})  & ReturnType< $shm_hitalama_map_float['style'] >
		font_size_px( ): string
		font_family( ): string
		event( ): ({ 
			contextmenu( next?: ReturnType< $shm_hitalama_map_widget_float['event_contextmenu'] > ): ReturnType< $shm_hitalama_map_widget_float['event_contextmenu'] >,
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float['pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float['pointerdown'] >,
		})  & ReturnType< $shm_hitalama_map_float['event'] >
		on_contextmenu( next?: any ): any
		locked( next?: boolean ): boolean
		z( next?: number ): number
		Contextmenu_body( ): $mol_list
		selected( next?: boolean ): boolean
		attr( ): ({ 
			'shm_hitalama_map_widget_float_ref': ReturnType< $shm_hitalama_map_widget_float['link_str'] >,
			'auto_height': ReturnType< $shm_hitalama_map_widget_float['auto_height'] >,
			'fullscreen': ReturnType< $shm_hitalama_map_widget_float['fullscreen_attr'] >,
			'shm_hitalama_map_widget_float_selected': ReturnType< $shm_hitalama_map_widget_float['selected_attr'] >,
			'shm_hitalama_map_widget_float_dragged': ReturnType< $shm_hitalama_map_widget_float['dragged_attr'] >,
			'shm_hitalama_map_widget_float_locked_selected': ReturnType< $shm_hitalama_map_widget_float['locked_selected'] >,
			'shm_hitalama_map_widget_float_locked': ReturnType< $shm_hitalama_map_widget_float['locked_attr'] >,
			'shm_hitalama_map_widget_float_hovered': ReturnType< $shm_hitalama_map_widget_float['hover_styled'] >,
			'shm_hitalama_map_widget_float_inner': ReturnType< $shm_hitalama_map_widget_float['is_inner'] >,
			'shm_hitalama_map_widget_float_control': ReturnType< $shm_hitalama_map_widget_float['control_attr'] >,
		})  & ReturnType< $shm_hitalama_map_float['attr'] >
	}
	
}

//# sourceMappingURL=float.view.tree.d.ts.map